export default {
  LIST_FETCHED: 'COUPON_CODES_FETCHED',
  LIST_LOAD: 'COUPON_CODES_LOAD',
  ITEM_DETAIL: 'COUPON_CODES_DETAIL',
  BUTTON_LOAD: 'COUPON_CODES_BUTTON_LOAD',
};
